export default __webpack_public_path__ + "static/media/Group 167.adca36c2.png";